import script from "./PrintInvoice.vue?vue&type=script&setup=true&lang=js"
export * from "./PrintInvoice.vue?vue&type=script&setup=true&lang=js"

import "./PrintInvoice.vue?vue&type=style&index=0&id=3447db6a&scoped=true&lang=css"
import "./PrintInvoice.vue?vue&type=style&index=1&id=3447db6a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3447db6a"]])

export default __exports__